export default __webpack_public_path__ + "static/media/cm_4.77ab4e8e.png";